exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "div.forgot-password-success-modal-container #instructions p {\n  margin-bottom: 20px; }\n", ""]);

